import { QueryClient } from '@tanstack/react-query';

/**
 * Query client for frontend booking fields
 *
 * Different cache strategy than admin:
 * - Shorter stale time (data changes frequently during booking)
 * - No background refetching (user-driven interactions)
 * - Aggressive garbage collection (form context)
 */
export const fieldQueryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1 * 60 * 1000, // 1 minute
			gcTime: 2 * 60 * 1000, // 2 minutes
			refetchOnWindowFocus: false,
			refetchOnReconnect: false,
			retry: 1,
		},
		mutations: {
			retry: 1,
		},
	},
});
